<template>
  <div id="sov">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div class="datepickerwrap card" style="flex-direction: row">
      <div class="leftcontent wrapitem d-flex">
        <div class=" custom_dropdown customMultiselect mr-3" style="width:35%">
          <div @click="showWebsiteMenu = !showWebsiteMenu" class="form-control custom_dropdown_wrap">
            <span class="custom_dropdown_title">{{ selected_website_label }}</span>
            <i class="fa fa-angle-down" style="font-size: 17px;"></i>
          </div>
          <div class="custom_websiteMenu" v-if="showWebsiteMenu">
            <span style="cursor:pointer; font-size: 9px;float:right;color: #a48cca;" @click="showWebsiteMenu = false"><i
                class="fa fa-times"></i> Close </span>
            <div v-for="d in websiteMenuItems" :key="d.optgroup" class="custom_websiteMenuItems">
              <div class="custom_optgroup">{{ d.optgroup }}</div>
              <div :class="{ active: selected_website == op.key }" class="custom_option" v-for="op in d.options"
                :key="d.optgroup + '_' + op.key">
                <input @change="customOptionSelected(d.optgroup, op.key, op.label, op.check)" type="checkbox"
                  v-model="op.check">
                <span>{{ op.label }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="datebox">
          <select v-model="device" @change="siteDeviceChange" class="form-control text-uppercase">
            <option value="laptop">Laptop</option>
            <!-- <option value="desktop">Desktop</option> -->
          </select>
        </div>
        <div class="datebox" style="width: 12% !important">
          <button @click="siteDeviceChange" class="btn primarycolor" type="button">
            <span>Submit</span>
          </button>
        </div>
        <div class="datebox custom_dropdown">
          <div @click="showProductModal" class="custom_dropdown_wrap" style="
            background: white;
            padding-left: 14px;
            border: 1px solid var(--base_color-40);
            border-radius: 5px;
            margin-left: -5px;
            padding-right: 14px;
            height: 2.2rem;
          ">
            <span class="custom_dropdown_title" style="
              margin-top: 0px;
              float: left;
              font-size: 12px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 201px;
            ">{{ selectedProduct.key }} &nbsp;</span>
            <i style="font-size: 17px" class="fa fa-angle-down"></i>
          </div>

        </div>
        <div class="datebox">
          <datepicker placeholder="From" @input="refreshReview" v-model="reviewStartDate" />
        </div>
        <div class="datebox">
          <datepicker v-model="reviewEndDate" class="picker-left" placeholder="To" @input="refreshReview" />
        </div>
      </div>
      <div class="righcontent wrapitem">
        <button @click="backToSov" style="float: right" class="btn navigationButton" type="button">
          <img src="Icons_SVG/Arrow_Left.svg" height="16" class="backIcon" style="margin-top: -3px" />
          <span style="font-size: 16px"> Back</span>
        </button>
        <button @click="goToSentiments" style="float: right; margin-right: 5px" class="btn navigationButton"
          type="button">
          <span style="font-size: 16px">Show Sentiments</span>
        </button>
      </div>
    </div>
    <div class="container-fluid ">
      <div class="card " style="padding: 20px">
        <b-row class="mt-1 ml-1 mb-2">
          <div style="display: flex; justify-content: flex-start" class="col-md-6">
            <div class="col-md-*">
              <p class="inputBoxTitle" style="margin-bottom: 0; padding: 7px; margin-left: -20px">
                Ratings:
              </p>
            </div>
            <div class="col-md-3  px-0 mr-2">
              <select v-model="reviewsRatingExp" class="form-control text-uppercase">
                <option value="eq">Equals to (=)</option>
                <option value="gt">Greater than (&gt;)</option>
                <option value="gte">Greater than equals to (&gt;=)</option>
                <option value="lt">Lower than</option>
                <option value="lte">Lower than equals to (&lt;=)</option>
                <option value="between">Between (&gt;= &amp;&amp; &lt;=)</option>
              </select>
            </div>
            <div class="col-md-3 px-0 mr-2">
              <input v-model="reviewsRatingInput" style="border: 1px solid silver !important;"
                class="form-control filval" type="text" placeholder="Enter Value">
              <input v-if="reviewsRatingExp == 'between'" v-model="reviewsRatingInput2"
                style="border: 1px solid silver !important;" class="form-control filval" type="text"
                placeholder="Enter Value">
            </div>
            <div class="col-md-1 pl-0">
              <button @click="refreshReview" class="btn exportButton"> Apply </button>
            </div>
          </div>
          <div class="col-md-6 pl-0" style="text-align: right;">
            <span style="position: relative; top: 2px; height: 35px; !important" class="lastUpdated mr-1">
              Last Updated: {{ moment(reviewsData.last_updated).format('MMM DD, YY') }}
            </span>
            <button @click="exportData" class="btn exportButton mr-1">Export</button>
          </div>
        </b-row>

        <table id="myTable">
          <thead class="thead-normal">
            <tr>
              <th style="width:9%">Partner</th>
              <th style="width:18%">Product Name</th>
              <th style="width:7%">Review<br />Date</th>
              <th style="width: 5%;">Rating</th>
              <th>Review Text</th>
              <th style="width: 6%;">Overall Rating</th>
              <th style="width: 6%;">Total Reviews</th>
              <th style="width: 8%;">CPU</th>
              <th style="width: 4%;">CPU Model</th>
            </tr>
          </thead>
          <tfoot style="display: table-row-group;">
            <tr>
              <th style="width:9%">Partner</th>
              <th style="width:18%">Product Name</th>
              <th style="width:7%">Review<br />Date</th>
              <th style="width: 5%;">Rating</th>
              <th>Review Text</th>
              <th style="width: 6%;">Overall Rating</th>
              <th style="width: 6%;">Total Reviews</th>
              <th style="width: 8%;">CPU</th>
              <th style="width: 4%;">CPU Model</th>
            </tr>
          </tfoot>
          <tbody class="tbody-normal" style="font-family:inherit">
            <tr v-for="(d, i) in reviewsData.data">
              <td :data-order="d.channel">{{ d.channel }}</td>
              <td>
                <div style="text-align:left;width:200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                  <a :title="d.product_name" :href="d.product_link">{{ d.product_name }}</a>
                </div>
              </td>
              <td :data-order="d.review_date">{{ d.review_date }}</td>
              <td :data-order="d.rating">{{ d.rating }}</td>
              <td :data-order="d.review" style="text-align: left;min-width:200px">
                <span v-show="d.review.length < 185">{{ d.review }}</span>
                <span v-show="d.review.length >= 185">
                  <span v-show="!reviewLayoutExpand.includes(i)">{{ d.review.slice(0, 185) }}...</span>
                  <span v-show="reviewLayoutExpand.includes(i)">{{ d.review }}</span>

                  <span @click="expandReview(i)" v-show="!reviewLayoutExpand.includes(i)"
                    style="color:#167495;cursor:pointer">Expand</span>
                  <span @click="collapseReview(i)" v-show="reviewLayoutExpand.includes(i)"
                    style="color:#167495;cursor:pointer"> Collapse</span>
                </span>
              </td>
              <td :data-order="d.product_rating">{{ d.product_rating }}</td>
              <td :data-order="d.review_count">{{ d.review_count }}</td>
              <td :data-order="d.cpu" style="text-transform:capitalize">{{ d.cpu.replace('amd', 'AMD') }}</td>
              <td :data-order="d.processor_model">{{ d.processor_model }}</td>
              <!-- <td>
                <div  class="each-review">
                  
                  <div class="usericon">
                    <i class="fa fa-user" style="font-size: 15px; color: silver;"></i>
                  </div>
                  <div class="username">
                    {{ d.person_name }}
                  </div>
                <div class="usertimestamp">
                  {{ d.review_date }}
                </div>  
                <div class="helpful">
                  Helpful: {{ d.found_helpful }}
                    <a :href="d.review_link" target="_blank">
                      Link
                    </a>
                </div>
                <div class="helpful" style="margin-right:5px">
                  Rating: {{d.rating}}
                 
                </div>
                <div class="usertext" style="text-align: justify;">
                  
                  {{ d.review }}
                </div>
              </div>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card">
        <div>
          <highcharts v-if="activeMultiChart" :options="multiProdChart"></highcharts>
        </div>
      </div>
      <div class="card">
        <div>
          <highcharts v-if="activeMultiChart" :options="percentChart"></highcharts>
        </div>
      </div>
      <b-row>
        <b-col sm="6" lg="6" class="mycols">
          <div class="card">
            <highcharts v-if="activeMultiChart" :options="keyWordPieChart"></highcharts>
          </div>
        </b-col>
        <b-col sm="6" lg="6">
          <div class="card">
            <div>
              <highcharts v-if="activeMultiChart" :options="ratingPieChart"></highcharts>
            </div>
          </div>
        </b-col>
        <b-col sm="12" lg="12">
          <div class="card">
          <div style="text-align:right">
            <button style="margin-bottom: 0.75rem !important" @click="exportCPUFamilyTable" class="btn exportButton">Export</button>
          </div>
          <table v-if="reviewsData.hasOwnProperty('graph_data')" id="keyword_newtable" class="table">
            <thead>
              <tr>
                <th rowspan="2" style="border-top-left-radius: 10px !important">Theme</th>
                <th rowspan="2">Count</th>
                    <th colspan="11" style="border-top-right-radius: 10px !important">
                      CPU Family
                    </th>
              </tr>
              <tr>
                <th v-for="th in reviewsData.graph_data.count_data[0].models" :key="'table_th_' + th.name">{{ th.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="d in reviewsData.graph_data.count_data" :key="'table_keywords_' + d.keyword">
                <td style="background: var(--secondary_competitor-10) !important">{{ d.keyword }}</td>
                <td>{{ d.total }}</td>
                <td v-for="d2 in d.models" :key="'table_td_' + d2.name">{{ d2.count }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        </b-col>
      </b-row>
    </div>
    <b-modal size="lg" title="Select  " v-model="isProductModal" class="customModal">
      <b-row>
        <div class="col-md-12">
          <div style="display: flex" class="searchInput">
            <input style="border-radius: 0; padding: 6px; font-size: 11px" class="form-control" v-model="schProduct"
              type="text" placeholder="Search" />
            <div class="searchIcon">
              <img src="Icons_SVG/Search.svg" />
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="pt-2">
        <div class="col-md-12 mt-1">
          <div class="row">
            <div class="col-md-2">
              <p class="mt-1 inputBoxTitle">OEM:</p>
            </div>
            <div class="col-md-10 customMultiselect">
              <select v-model="brandFilter" @change="changeFilter" class="form-control">
                <option value="">All</option>
                <option style="text-transform:capitalize;" v-for="d in filterKeys.brand" :value="d" :key="d">{{
            d.replace('msi', 'MSI').replace('hp', 'HP') }}</option>
              </select>

            </div>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="row">
            <div class="col-md-2 mt-1">
              <p class="inputBoxTitle">Processor:</p>
            </div>
            <div class="col-md-10 customMultiselect">
              <select v-model="cpuFilter" @change="changeFilter" class="form-control fluid">
                <option value="">All</option>
                <option style="text-transform:capitalize" v-for="d in filterKeys.processor_type" :value="d" :key="d">{{
            d.replace('amd', 'AMD') }}</option>
              </select>
            </div>

          </div>
        </div>
      </b-row>
      <b-row class="pt-1 mt-1">
        <div class="col-md-2">
          <p class="mt-1 inputBoxTitle">Ratings:</p>
        </div>
        <div class="ratingSection col-md-10">
          <div class="ratingSectionItem mr-1">

            <select v-model="ratingExp" class="form-control text-uppercase">
              <option value="eq">Equals to (=)</option>
              <option value="gt">Greater than (&gt;)</option>
              <option value="gte">Greater than equals to (&gt;=)</option>
              <option value="lt">Lower than</option>
              <option value="lte">Lower than equals to (&lt;=)</option>
              <option value="between">Between (&gt;= &amp;&amp; &lt;=)</option>
            </select>
          </div>
          <div class="pl-0 mx-1 ratingSectionItem">
            <input min="0" max="5" v-model="ratingInput1" style="border: 1px solid silver !important"
              class="form-control filval" type="number" placeholder="Enter Value">

          </div>
          <div v-if="ratingExp == 'between'" class="mx-1 ratingSectionItem">
            <input min="0" max="5" v-model="ratingInput2" style="border: 1px solid silver !important;"
              class="form-control filval" type="number" placeholder="Enter Value">

          </div>
          <div class="pl-1">
            <button @click="applyRatingFilter" class="btn btn primarycolor mx-1"> Apply </button>
            <button @click="removeRatingFilter" class="btn primarycolor mx-1"
              style="background-color: var(--red); padding-right: 7px; padding-left: 7px"> Remove </button>
          </div>
        </div>

      </b-row>
      <b-row style="margin-top: 10px;">
        <div class="col-md-3 pr-0">
          <div class="checkbox-btn">
            <input @change="changeFilter" v-model="fourKSeries" type="checkbox" />
            <span>4000 Series</span>
          </div>
        </div>
        <div class="col-md-3 pr-0 pl-1">
          <div class="checkbox-btn">
            <input @change="changeFilter" v-model="fiveKSeries" type="checkbox" />
            <span>5000 Series</span>
          </div>
        </div>

      </b-row>
      <div style="padding-top: 20px; align-items: center; border-bottom: 1px solid #c1c1c1; padding-bottom:10px">
        <h5 class="m-0 graphHeading" style="margin-bottom: 0px !important">Products:</h5>
      </div>
      <div class="productScroll">
        <!-- <div :class="{ 'selectedProduct': selectedProduct.key == 'all' }" style="padding: 4px"
          @click="selectProductNow({ key: 'all' })">
        </div> -->
        <div style="padding: 4px">All</div>
        <div :class="{ 'selectedProduct': selectedProduct.key == d.key }" v-if="checkSearchFilter(d.key)"
          class="eachProduct " @click="selectProductNow(d)" style="padding: 4px; margin-top:7px" :key="d.key"
          v-for="d in productOptions">
          <span style="
          color: white;
          background: #548f92;
          margin-right: 10px;
          padding: 4px;
          border-radius: 5px;
          text-align: center;
        ">{{ d.channel.replace('_',
            '').toUpperCase() }}</span>
          <span>{{ d.key }} </span>

        </div>

      </div>
    </b-modal>
    <b-modal size="xl" :title="keywordModalTitle" v-model="isKeywordTableModal" class="customModal">
      <button style="position: absolute; right: 18px; top: 12px; z-index: 999" @click="exportModalKeywordTable"
      class="btn exportButton">
      Export
    </button>
      <table id="keywordTableModal">
        <thead class="thead-normal">
          <tr>
            <th style="width:9%">Partner</th>
            <th style="width:18%">Product Name</th>
            <th style="width:7%">Review<br />Date</th>
            <th style="width: 5%;">Rating</th>
            <th>Review Text</th>
            <th style="width: 6%;">Overall Rating</th>
            <th style="width: 6%;">Total Reviews</th>
            <th style="width: 8%;">CPU</th>
            <th style="width: 4%;">CPU Model</th>
          </tr>
        </thead>
        <tfoot style="display: table-row-group;">
          <tr>
            <th style="width:9%">Partner</th>
            <th style="width:18%">Product Name</th>
            <th style="width:7%">Review<br />Date</th>
            <th style="width: 5%;">Rating</th>
            <th>Review Text</th>
            <th style="width: 6%;">Overall Rating</th>
            <th style="width: 6%;">Total Reviews</th>
            <th style="width: 8%;">CPU</th>
            <th style="width: 4%;">CPU Model</th>
          </tr>
        </tfoot>
        <tbody class="tbody-normal" style="font-family:inherit">
          <tr v-for="(d, i) in keywordTableModalData">
            <td :data-order="d.channel">{{ d.channel }}</td>
            <td :data-order="d.product_name">
              <div style="text-align:left;width:200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                <a :title="d.product_name" :href="d.product_link">{{ d.product_name }}</a>
              </div>
            </td>
            <td :data-order="d.review_date">{{ d.review_date }}</td>
            <td :data-order="d.rating">{{ d.rating }}</td>
            <td :data-order="d.review" style="text-align: left;min-width:200px">
              <span v-show="d.review.length < 185">{{ d.review }}</span>
              <span v-show="d.review.length >= 185">
                <span v-show="!reviewLayoutExpand.includes(i)">{{ d.review.slice(0, 185) }}...</span>
                <span v-show="reviewLayoutExpand.includes(i)">{{ d.review }}</span>

                <span @click="expandReview(i)" v-show="!reviewLayoutExpand.includes(i)"
                  style="color:#167495;cursor:pointer">Expand</span>
                <span @click="collapseReview(i)" v-show="reviewLayoutExpand.includes(i)"
                  style="color:#167495;cursor:pointer"> Collapse</span>
              </span>
            </td>
            <td :data-order="d.product_rating">{{ d.product_rating }}</td>
            <td :data-order="d.review_count">{{ d.review_count }}</td>
            <td :data-order="d.cpu" style="text-transform:capitalize">{{ d.cpu.replace('amd', 'AMD') }}</td>
            <td :data-order="d.processor_model">{{ d.processor_model }}</td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>
<script>

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'


export default {
  name: 'sov',
  components: { Datepicker },
  data: function () {
    return {
      selected_website: '',
      websiteMenuItems: [{
        optgroup: '',
        options: [
          { key: 'https://www.hp.com/in-en', label: 'HP India', check: true },
          { key: 'https://www.hp.com/in-en#commercial', label: 'Commercial HP India', check: false },
        ]
      }],
      websitesUrls: {
        "https://www.hp.com/in-en": "hp_india",
        "https://www.hp.com/in-en#commercial": "commercial_hp_india",
      },
      reviewStarData: [],
      sentimentData: {},
      sentimentChart: {},
      activeSentimentChart: false,
      selectedProduct: {},
      productOptions: [],
      productOptionsFull: [],
      reviewStartDate: moment().subtract(1, 'week').format('YYYY-MM-DD'),
      reviewEndDate: moment().format('YYYY-MM-DD'),
      loader: true,
      modalTitle: '',
      modalSentimentType: '',
      keywordChartData: {},
      showModal: false,
      modalLoader: false,
      chartDataKey: 'original_frequency',
      chartDataMapper: {
        'original_score': 'Score',
        'original_frequency': 'Frequency',
        'reviews_count': 'Reviews Count'
      },
      interval: 'month',
      activeModalChart: false,
      modalData: {},
      isProductModal: false,
      schProduct: '',
      reviewLayoutExpand: [],
      deviceMapper: {
        'laptop': 'Laptop',
        'desktop': 'Desktop'
      },
      device: 'laptop',
      ratingInput1: '',
      ratingExp: 'eq',
      ratingInput2: '',
      pickProduct: false,
      filterChanged: false,
      cpuFilter: '',
      brandFilter: '',
      filterKeys: {
        brand: [],
        processor_type: []
      },
      reviewsRatingExp: 'eq',
      reviewsRatingInput: '',
      reviewsRatingInput2: '',
      reviewsData: {},
      updateSelectedProduct: false,
      moment: moment,
      fourKSeries: false,
      fiveKSeries: false,
      showWebsiteMenu: false,
      selected_website_label: 'HP India',
      selected_website_array: ['https://www.hp.com/in-en'],
      selected_website_channel_array: ['hp_india'],
      multiProdChart: {},
      activeMultiChart: false,
      percentChart: {},
      isKeywordTableModal: false,
      keywordTableModalData: [],
      keywordModalTitle: ''
    }
  },

  mounted() {
    if (localStorage.selected_website) {
      this.device = 'laptop'
      this.selected_website_array = [localStorage.selected_website]
      this.selected_website_channel_array = [this.websitesUrls[localStorage.selected_website]]
      for (let [i, r] of this.websiteMenuItems.entries()) {
        for (let [ii, rr] of r.options.entries()) {
          if (rr.key == localStorage.selected_website) {
            this.selected_website_label = rr.label
            rr.check = true
          }
        }
      }
    }
    else {
      this.device = 'laptop'
      this.websiteMenuItems[0].options[0].check = true

    }

    if (localStorage.cpuFilter) this.cpuFilter = localStorage.cpuFilter
    if (localStorage.brandFilter) this.brandFilter = localStorage.brandFilter
    if (localStorage.ratingExp) this.ratingExp = localStorage.ratingExp
    if (localStorage.ratingInput1) this.ratingInput1 = localStorage.ratingInput1
    if (localStorage.ratingInput2) this.ratingInput2 = localStorage.ratingInput2
    if (localStorage.fourKSeries) this.fourKSeries = JSON.parse(localStorage.fourKSeries)
    if (localStorage.fiveKSeries) this.fiveKSeries = JSON.parse(localStorage.fiveKSeries)

    if (localStorage.reviewStartDate) {
      this.reviewStartDate = localStorage.reviewStartDate
      this.reviewEndDate = localStorage.reviewEndDate
    }
    else {
      this.reviewStartDate = moment().subtract(2, 'month').format('YYYY-MM-DD')
      this.reviewEndDate = this.date.startDate
    }

    this.getProducts()
  },
  methods: {
    exportCPUFamilyTable() {
      let self = this
      let payload = {
        header: [],
        data: [],
        file_type: 'keyword_score'
      }
      payload.header = [
        { key: 'keyword', label: ' ' },
        { key: 'total', label: ' ' },
      ]
      for (let [i, r] of self.reviewsData.graph_data.count_data[0].models.entries()) {
        let label = ' '
        if (i == 0) label = 'CPU Family'
        payload.header.push({ key: r.name, label: label })
      }

      for (let [i, r] of self.reviewsData.graph_data.count_data.entries()) {
        if (i == 0) {
          let obj = { 'keyword': 'Theme', 'total': 'Count' }
          for (let [ii, rr] of r.models.entries()) {
            obj[rr.name] = rr.name
          }
          payload.data.push(obj)
        }
        let obj = { 'keyword': r.keyword, 'total': r.total }
        for (let [ii, rr] of r.models.entries()) {
          obj[rr.name] = rr.count
        }
        payload.data.push(obj)
      }
      const url = "/api/websites/export"
      self.$http.post(url, payload).then(response => {
        window.location = response.body.file
        self.loader = false
      }, err => {
        self.loader = false
      });
    },
    exportModalKeywordTable() {
      let self = this
      let payload = {
        header: [],
        data: [],
        file_type: 'keyword_review_' + self.keywordModalTitle
      }
      payload.header = [
        { key: 'channel', label: 'Partner' },
        { key: 'product_name', label: 'Product Name' },
        { key: 'product_link', label: 'Product Link' },
        { key: 'review_date', label: 'Review Date' },
        { key: 'rating', label: 'Rating' },
        { key: 'review', label: 'Review Text' },
        { key: 'product_rating', label: 'Overall Rating' },
        { key: 'review_count', label: 'Total Reviews' },
        { key: 'cpu', label: 'CPU' },
        { key: 'processor_model', label: 'CPU Model' },
      ]
      payload.data = self.keywordTableModalData

      const url = "/api/websites/export"
      self.$http.post(url, payload).then(response => {
        window.location = response.body.file
        self.loader = false
      }, err => {
        self.loader = false
      });
    },
    customOptionSelected(optgroup, value, label, check) {
      let self = this
      if (check) {
        self.selected_website_label = label
        this.selected_website_array.push(value)
        this.selected_website_channel_array.push(this.websitesUrls[value])
      }
      else {
        if (this.selected_website_array.includes(value))
          this.selected_website_array.splice(this.selected_website_array.indexOf(value), 1)
        if (this.selected_website_channel_array.includes(this.websitesUrls[value]))
          this.selected_website_channel_array.splice(this.selected_website_channel_array.indexOf(this.websitesUrls[value]), 1)
      }
      if (!this.selected_website_array.length) {
        self.selected_website_label = "No website selected"
      }
    },
    siteDeviceChange() {
      let self = this
      self.showWebsiteMenu = false
      self.updateSelectedProduct = true
      localStorage.selected_website = self.selected_website
      localStorage.selected_category = self.device
      self.getProducts()
    },
    exportData() {
      let self = this
      self.loader = true
      setTimeout(function () {
        let payload = {
          "start_date": moment(self.reviewStartDate).format('YYYY-MM-DD'),
          "end_date": moment(self.reviewEndDate).format('YYYY-MM-DD'),
          "interval": self.revInterval,
          "client": "AMD",
          "item_category": self.device,
        }
        if (self.reviewsRatingInput) {
          payload['rating'] = {}
          if (self.reviewsRatingExp != 'between') {
            payload['rating'][self.reviewsRatingExp] = self.reviewsRatingInput
          }
          else {
            payload['rating']['lte'] = self.reviewsRatingInput2
            payload['rating']['gte'] = self.reviewsRatingInput
          }
        }

        if (self.selected_website != 'all') {
          payload["channel"] = self.selected_website_channel_array
        }
        if (self.selectedProduct.key != 'all') {
          payload["product_name"] = [self.selectedProduct.key]
        }
        if (self.ratingInput1) {
          if (self.pickProduct) {
            if (self.selectedProduct.key != 'all')
              payload["product_name"] = [self.selectedProduct.key]
            else {
              payload["product_name"] = []
              for (let [ii, rr] of this.productOptions.entries()) {
                payload["product_name"].push(rr.key)
              }

            }

          }
          else {
            payload["product_name"] = []
            for (let [ii, rr] of this.productOptions.entries()) {
              payload["product_name"].push(rr.key)
            }
          }
        }

        const url = "/api/reviews/download/amd"
        self.$http.post(url, payload).then(response => {
          self.loader = false
          window.location = response.body.data
        }, err => {
          self.loader = false
        });

      }, 100)
    },
    expandReview(i) {
      this.reviewLayoutExpand.push(i)
    },
    collapseReview(i) {
      let arIdx = this.reviewLayoutExpand.indexOf(i)
      this.reviewLayoutExpand.splice(arIdx, 1)

    },
    changeFilter() {
      this.pickProduct = false
      this.selectedProduct = { key: 'all' }
      localStorage.selected_product = JSON.stringify(this.selectedProduct)
      this.filterChanged = true
      if (this.cpuFilter) localStorage.cpuFilter = this.cpuFilter
      else delete localStorage.cpuFilter
      if (this.brandFilter) localStorage.brandFilter = this.brandFilter
      else delete localStorage.brandFilter
      if (this.ratingExp) localStorage.ratingExp = this.ratingExp
      else delete localStorage.ratingExp
      if (this.ratingInput1) localStorage.ratingInput1 = this.ratingInput1
      else delete localStorage.ratingInput1
      if (this.ratingInput2) localStorage.ratingInput2 = this.ratingInput2
      else delete localStorage.ratingInput2
      if (this.fourKSeries) localStorage.fourKSeries = JSON.stringify(this.fourKSeries)
      else delete localStorage.fourKSeries
      if (this.fiveKSeries) localStorage.fiveKSeries = JSON.stringify(this.fiveKSeries)
      else delete localStorage.fiveKSeries
      this.filterActions()
    },
    removeRatingFilter() {
      this.ratingInput1 = ''
      this.ratingInput2 = ''
      if (localStorage.ratingExp) delete localStorage.ratingExp
      if (localStorage.ratingInput1) delete localStorage.ratingInput1
      if (localStorage.ratingInput2) delete localStorage.ratingInput2
      this.changeFilter()
    },
    applyRatingFilter() {
      let self = this
      if (self.ratingInput1 > 5) {
        alert('Rating value should be between 0 and 5')
        return false
      }
      if (self.ratingInput1 < 0) {
        alert('Rating value should be between 0 and 5')
        return false
      }
      if (self.ratingExp == 'between') {
        if (self.ratingInput2 > 5) {
          alert('Rating value should be between 0 and 5')
          return false
        }
        if (self.ratingInput2 < 0) {
          alert('Rating value should be between 0 and 5')
          return false
        }
      }
      self.changeFilter()
    },
    checkChannel() {
      if ((this.selected_website == 'https://www.amazon.com') || (this.selected_website == 'https://www.harveynorman.com.au') || (this.selected_website == 'https://www.costco.com') || (this.selected_website == 'https://www.walmart.com') || (this.selected_website == 'https://global.jd.com') || (this.selected_website == 'https://www.bestbuy.com') || (this.selected_website == 'https://www.currys.co.uk') || (this.selected_website == 'https://www.mediamarkt.de')) {
        return true
      }
      else {
        return false
      }
    },
    checkSearchFilter(d) {
      let self = this
      if (d.toLowerCase().indexOf(self.schProduct.toLowerCase()) != -1) {
        return true
      }
      else {
        return false
      }
    },
    goToSentiments() {
      let self = this
      window.location = "#/sentiments-amd-oem"
    },
    selectProductNow(d) {
      let self = this
      self.selectedProduct = d
      self.pickProduct = true
      localStorage.selected_product = JSON.stringify(self.selectedProduct)
      self.refreshReview()
      self.isProductModal = false
    },
    showProductModal() {
      let self = this
      self.isProductModal = true
    },
    formatDate(key, d) {
      let self = this
      let obj = {
        'day': moment(d).format('MMM DD, YY'),
        'month': moment(d).format('MMM YY'),
        'week': ''
      }
      if (self[key] == 'week') {
        let end_date = moment(d).add(6, 'days')
        let today = moment(self.reviewEndDate)
        if (end_date >= today)
          end_date = today
        obj['week'] = moment(d).format('MMM DD, YY') + " - " + moment(end_date).format('MMM DD, YY')
      }
      return obj[this[key]]
    },
    backToSov() {
      window.location = '#/sov-summary-amd'
    },
    changeSentimentType(d) {
      this.$nextTick(function () {
        this.modalSentimentType = d
        this.getKeywordWiseData()
      })
    },
    getKeywordWiseData() {
      let self = this
      self.modalLoader = true
      self.loader = true
      if (Object.keys(self.modalData).length) {
        $('#myTable').DataTable().destroy();
      }
      self.modalData = {}
      let url = "/api/reviews/keywordwise"
      url += "?keyword=" + self.modalTitle
      url += "&product_name=" + self.selectedProduct.key

      url += "&channel=" + self.websitesUrls[self.selected_website]
      if (self.modalSentimentType)
        url += "&sentiment_type=" + self.modalSentimentType
      url += "&start_date=" + this.reviewStartDate + "&end_date=" + this.reviewEndDate
      self.$http.get(url).then(response => {
        self.modalData = response.body
        self.modalLoader = false
        self.loader = false
        if (!self.showModal) self.showModal = true
      }, err => {
        self.modalLoader = false
        self.loader = false
      });
    },

    processChartData() {
      let category = []
      let series = []
      let comm_series = []
      let datakeys = [{ key: 'positive', label: 'Positive', color: 'green' }, { key: 'negative', label: 'Negative', color: 'red' }]
      let self = this
      let new_key = ""
      let org_label = ""
      let com_label = ""
      if (this.chartDataKey == "original_frequency") {
        new_key = "frequency"
        org_label = "Frequency"
        com_label = "Cummulative Frequency"
      }
      else if (this.chartDataKey == "original_score") {
        new_key = "score"
        org_label = "Score"
        com_label = "Cummulative Score"
      }
      else {
        new_key = "cummulative_review_count"
        org_label = "Review Count"
        com_label = "Cummulative Review Count"
      }
      for (let [i, k] of datakeys.entries()) {
        if (this.keywordChartData.data[k.key]) {
          let obj = {}
          obj.name = k.label
          obj.data = []
          obj.color = k.color
          let comm_obj = {}
          let format_date = ""
          comm_obj.name = k.label
          comm_obj.data = []
          comm_obj.color = k.color
          for (let [idx, dataset] of this.keywordChartData.data[k.key].entries()) {

            category.push(self.formatDate('interval', dataset.date))
            obj.data.push(dataset[this.chartDataKey])
            comm_obj.data.push(dataset[new_key])
          }
          series.push(obj)
          comm_series.push(comm_obj)
        }
      }
      this.plotChart({ series: series, category: category }, 'modalChart', org_label)
      this.plotChart({ series: comm_series, category: category }, 'cmodalChart', com_label)
    },
    plotChart(d, chartObj, chart_label) {
      var self = this
      if (d.category.length)
        self.activeModalChart = true
      else
        self.activeModalChart = false
      this[chartObj] =
      {
        credits: {
          enabled: false
        },
        chart: {
          height: 210
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },

        yAxis: {
          title: {
            text: chart_label
          }
        },
        xAxis: {
          categories: d.category,
          crosshair: true,
          crosshair: {
            color: 'rgba(166, 215, 238)',
            width: 2,
          }
        },
        tooltip: {
          formatter: function () {
            var mytooltip = this.points[0].key + '<br/>';
            for (var i = 0; i < this.points.length; i++) {
              mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
              mytooltip += this.points[i].series.name
              mytooltip += ' : <b> ' + self.format(this.points[i].y) + '</b> <br/>';
            }
            return mytooltip;
          },
          shared: true
        },
        plotOptions: {
          series: {
            lineWidth: 1.2,
            marker: {
              radius: 1.9
            }
          }
        },
        series: d.series
      }
    },
    refreshModal() {
      let self = this
      self.reviewStartDate = moment(self.reviewStartDate).format('YYYY-MM-DD')
      self.reviewEndDate = moment(self.reviewEndDate).format('YYYY-MM-DD')
      this.getKeywordChartData()
      this.getKeywordWiseData()
    },
    openModal(keyword, type) {
      this.modalTitle = keyword
      this.modalSentimentType = type
      this.refreshModal('datecomponent')
    },
    getKeywordChartData() {
      let self = this
      self.modalLoader = true
      self.loader = true
      self.$nextTick(function () {
        self.keywordChartData = {}
        let url = "/api/reviews/keywisesentdata?interval=" + self.interval
        url += "&keyword=" + self.modalTitle
        url += "&product_name=" + self.selectedProduct.key
        url += "&channel=" + self.websitesUrls[self.selected_website]
        if (self.modalSentimentType)
          url += "&sentiment_type=" + self.modalSentimentType

        url += "&start_date=" + this.reviewStartDate + "&end_date=" + this.reviewEndDate
        self.$http.get(url).then(response => {
          self.keywordChartData = response.body
          self.modalLoader = false
          self.loader = false
          self.processChartData()
        }, err => {
          self.modalLoader = false
          self.loader = false
        });
      })
    },
    drawGaugeChart(word, positive, negative) {
      let self = this
      let series = []
      let value1 = Number(positive)
      let value2 = Number(negative)
      if (value1 && value2) {
        let obj = {}
        obj.name = "Positive"
        obj.color = "#7fc557"
        obj.y = value1
        series.push(obj)
        let obj2 = {}
        obj2.name = "Negative"
        obj2.color = "#fb7b63"
        obj2.y = value2
        series.push(obj2)
      }
      else {
        if (!value1) {
          let obj = {}
          obj.name = "Negative"
          obj.color = "#fb7b63"
          obj.y = value2
          series.push(obj)
          let obj2 = {}
          obj2.name = "other"
          obj2.color = "whitesmoke"
          obj2.y = 100 - value2
          obj2.dataLabels = { enabled: false }
          series.push(obj2)
        }
        if (!value2) {
          let obj = {}
          obj.name = "Positive"
          obj.color = "#7fc557"
          obj.y = value1
          series.push(obj)
          let obj2 = {}
          obj2.name = "other"
          obj2.color = "whitesmoke"
          obj2.y = 100 - value1
          obj2.dataLabels = { enabled: false }
          series.push(obj2)
        }
      }
      this.sentimentChart[word] = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          margin: [0, 0, 0, 0],
          padding: [0, 0, 0, 0],
          height: 110,
          width: 180
        },
        title: {
          text: '',
        },
        credits: {
          enabled: false
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        tooltip: {
          formatter() {
            if (this.point.name == 'other') {
              return false
            }
            var mytooltip = ''
            // console.log(this.point)
            mytooltip += '<span style="color:' + this.point.color + '!important">\u25CF</span> '
            mytooltip += this.point.name
            mytooltip += ' : <b> ' + self.format(this.point.y) + '%</b> <br/>'
            return mytooltip;
          },
        },
        plotOptions: {
          series: {
            borderWidth: 0,
          },
          pie: {
            dataLabels: {
              enabled: true,
              distance: -15,
              format: '{point.y:.1f}',
              style: {
                fontSize: 11,
              },
              color: 'black'
            },
            showInLegend: true,
            startAngle: -90,
            endAngle: 90,
            size: '100%',
            center: ['50%', '57%'],
          }
        },
        legend: {
          enabled: false,
          itemStyle: {
            fontSize: 9,
            fontWeight: 1,
          }
        },
        series: [{
          type: 'pie',
          innerSize: '59%',
          data: series
        }]
      }
    },
    getSentiment() {
      let self = this
      self.loader = true
      let payload = {
        "product_name": self.selectedProduct.key,
        "channel": self.websitesUrls[self.selected_website],
        "start_date": moment(self.reviewStartDate).format('YYYY-MM-DD'),
        "end_date": moment(self.reviewEndDate).format('YYYY-MM-DD'),
        "item_category": self.device,
      }
      const url = "/api/websites/review_sentiment"
      self.$http.post(url, payload).then(response => {
        self.loader = false
        self.sentimentData = response.body.table
        for (let [y, td] of response.body.table.entries()) {
          if (td.positive_score == null) {
            td.positive_score = 0
          }
          if (td.negative_score == null) {
            td.negative_score = 0
          }
          self.drawGaugeChart(td.word, td.positive_score, td.negative_score)
        }

      }, err => {
        self.loader = false
      });
    },
    refreshReview() {
      let self = this
      localStorage.reviewStartDate = this.reviewStartDate
      localStorage.reviewEndDate = this.reviewEndDate

      if (self.selectedProduct.key) {
        localStorage.selected_product = JSON.stringify(self.selectedProduct)
        self.getReviews()
      }
    },

    processMultiProductChartData(data, options) {
      let self = this
      let cat = []
      let totalData = []
      let seriesData = []
      let seriesObj = {}
      let column_colors = ["#47A694", "#54736D", "#265950", "#79A69E"];
      for (let [idx, ds] of data.entries()) {
        cat.push(ds.keyword)
        for (let [idx2, ds2] of ds.models.entries()) {
          if (seriesObj.hasOwnProperty(ds2.name)) {
            seriesObj[ds2.name].push(ds2.count)
          }
          else {
            seriesObj[ds2.name] = [ds2.count]
          }
        }
        totalData.push(ds.total)
      }
      let i = 0;
      for (let [key, value] of Object.entries(seriesObj)) {
        seriesData.push({ name: key, data: value,color: column_colors[i] })
        i++;
      }
      seriesData.push({ name: 'Total', data: totalData, type: 'line', color: '#FCB116', lineWidth: 0, lineColor: 'transparent', marker: { symbol: 'diamond' } })

      self[options.chartKey] = {
        chart: {
          type: 'column',
          height: 250
        },
        credits: { enabled: false },
        title: {
          text: options.title,
          align: "left",
          style: {
            color: "#065559",
            fontFamily: "Poppins",
            fontWeight: "bold",
          },
        },
        subtitle: {
          text: ''
        },
        xAxis: {
          categories: cat,
          crosshair: true
        },
        legend: { enabled: true,
          alignColumns: true,
          align: "right",
          y: -35,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4, },
        yAxis: {
          min: 0,
          title: {
            text: 'Frequency'
          }
        },
        tooltip: {
          shared: true,
          valueSuffix: options.tooltipSuffix || ''
        },
        series: seriesData
      }
      setTimeout(function () {
        self.activeMultiChart = true
      }, 10)
    },

    keywordPieClick(data) {
      let self = this
      if (self.keywordTableModalData.length) {
        $('#keywordTableModal').DataTable().destroy();
      }
      self.keywordTableModalData = []
      for (let [idx, ds] of self.reviewsData.graph_data.keyword_review_list.entries()) {
        if (ds.keywords.includes(data.name)) {
          self.keywordTableModalData.push(ds)
        }
      }
      self.initDT('keywordTableModal')
      self.keywordModalTitle = data.name
      self.isKeywordTableModal = true
    },

    processPieRatingKeywordData(data, options) {
      let self = this
      let seriesData = []
      let color_codes = [
        "#47A694",
        "#54736D",
        "#265950",
        "#79A69E",
        "#317367",
        "#54736D",
        "#52BFAB",
        "#84B5AC",
        "#5F827C",
        "#388273",
        "#59CFB7",
      ];
      for (let [idx, ds] of data.entries()) {
        if (options.chartKey == 'ratingPieChart')
          seriesData.push({ name: ds.name + ' Star', y: ds.value })
        else
          seriesData.push({ name: ds.name, y: ds.value })
      }
      let plotSeries = { borderWidth: 0 }
      if (options.chartKey == 'keyWordPieChart') {
        plotSeries = {
          borderWidth: 0,
          cursor: 'pointer',
          point: {
            events: {
              click: function () {
                self.keywordPieClick(this)
              }
            }
          }
        }
      }

      self[options.chartKey] = {
        chart: {


        },
        title: {
          text: options.title,
          margin: 25,
          verticalAlign: "bottom",
          style: {
            color: "#01695C",
            fontSize: "15px",
            fontWeight: "bold",
          },
        },
        credits: {
          enabled: false
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        tooltip: {
          formatter() {
            var mytooltip = ''
            mytooltip += '<span style="font-size:22px;color:' + this.point.color + '">\u25CF</span> '
            mytooltip += this.point.name
            mytooltip += ' : <b> ' + this.point.y + ' (' + this.point.percentage.toFixed(2) + '%)</b> <br/>'
            mytooltip += 'Total: <b>' + this.point.total + '</b>'
            return mytooltip;
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        plotOptions: {
          series: plotSeries,
          pie: {
            dataLabels: {
              enabled: true,
              useHTML: true,
              formatter: function () {
                self.pieTotal = this.point.total

                return '<span style="color:white;font-size:11px;font-weight:normal;">' + self.format(this.point.percentage.toFixed()) + '%</span>'
              },
              distance: -30,
              style: {
                fontSize: 11,
              }
            },
            showInLegend: true,
            size: '100%',
            colors: color_codes,
            innerSize: "50%",
          }
        },
        legend: {
          enabled: true,
          alignColumns: true,
          layout: "horizontal",
          align: "right",
          y: -7,
          x: -30,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 20,
          itemMarginBottom: 6,
          margin: 15,
          marginLeft: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
        },
        series: [{
          type: 'pie',
          data: seriesData
        }]
      }
    },
    getReviews() {
      let self = this
      self.loader = true
      let payload = {
        "start_date": moment(self.reviewStartDate).format('YYYY-MM-DD'),
        "end_date": moment(self.reviewEndDate).format('YYYY-MM-DD'),
        "interval": self.revInterval,
        "client": "AMD",
        "item_category": self.device,
        "channel": self.selected_website_channel_array
      }
      if (self.brandFilter) {
        payload['brand'] = self.brandFilter
      }
      if (self.cpuFilter) {
        payload['processor'] = self.cpuFilter
      }
      if (self.reviewsRatingInput) {
        payload['rating'] = {}
        if (self.reviewsRatingExp != 'between') {
          payload['rating'][self.reviewsRatingExp] = self.reviewsRatingInput
        }
        else {
          payload['rating']['lte'] = self.reviewsRatingInput2
          payload['rating']['gte'] = self.reviewsRatingInput
        }
      }


      if (self.selectedProduct.key != 'all') {
        payload["product_name"] = [self.selectedProduct.key]
      }
      if (self.ratingInput1 || self.fourKSeries || self.fiveKSeries) {
        if (self.pickProduct) {
          if (self.selectedProduct.key != 'all')
            payload["product_name"] = [self.selectedProduct.key]
          else {
            payload["product_name"] = []
            for (let [ii, rr] of this.productOptions.entries()) {
              payload["product_name"].push(rr.key)
            }
          }
        }
        else {
          payload["product_name"] = []
          for (let [ii, rr] of this.productOptions.entries()) {
            payload["product_name"].push(rr.key)
          }
        }
      }
      if (Object.keys(self.reviewsData).length) {
        $('#myTable').DataTable().destroy();
      }
      self.reviewsData = {}

      const url = "/api/reviews/list"
      self.$http.post(url, payload).then(response => {
        self.loader = false
        self.reviewsData = response.body
        self.processMultiProductChartData(response.body.graph_data.count_data, { type: 'count', chartKey: 'multiProdChart', title: 'Number of 1 and 2 Star Reviews by CPU family' })
        self.processMultiProductChartData(response.body.graph_data.percent_data, { tooltipSuffix: '%', type: 'percent', chartKey: 'percentChart', title: 'Percentage of 1 and 2 Star Reviews by CPU family' })
        self.processPieRatingKeywordData(response.body.graph_data.all_keyword_data, { chartKey: 'keyWordPieChart', title: 'Keyword Density' })
        self.processPieRatingKeywordData(response.body.graph_data.all_rating_data, { chartKey: 'ratingPieChart', title: 'Ratings Distribution' })
        self.initDT('myTable')
      }, err => {
        self.loader = false
      });

    },
    initDT(id) {
      let self = this
      let pageLength = { 'myTable': 10, 'keywordTableModal': 10 }
      let bLengthChange = { 'myTable': true, 'keywordTableModal': true }
      self.$nextTick(function () {
        if (self.reviewsData.data.length) {
          $('#' + id).dataTable({
            language: {
              search: "",
              paginate: {
                first: "",
                previous: "<",
                next: ">",
                last: "",
              },
              lengthMenu: "<h5>Show entries</h5> _MENU_",
            },
            pagingType: "full_numbers",
            searching: true,
            bLengthChange: bLengthChange[id],
            pageLength: pageLength[id],
            autoWidth: false,
            initComplete: function () {
              this.api().columns().every(function () {
                var column = this;
                var select = $('<select><option value="">All</option></select>')
                  .appendTo($(column.footer()).empty())
                  .on('change', function () {
                    var val = $.fn.dataTable.util.escapeRegex($(this).val());
                    column.search(val ? '^' + val + '$' : '', true, false).draw();
                  });
                if (this.index() == 4) return
                let arr = []
                let sortedArr = []
                column.data().unique().sort().each(function (d, j) {
                  if (!d.includes('<span') && !d.includes('<div')) {
                    arr.push(d)
                  }
                  else {
                    var myVal = $(d).text()
                    arr.push(myVal)
                  }

                });

                sortedArr = arr.sort((a, b) => a.localeCompare(b, navigator.languages[0] || navigator.language, { numeric: true, ignorePunctuation: true }))

                for (let [idx, ds] of sortedArr.entries()) {
                  select.append('<option value="' + ds + '">' + ds + '</option>')
                }
              });
            }
          })
          let search =  require("../../../public/Icons_SVG/Search.svg");
          if (bLengthChange[id])
            $("#" + id + "_filter > label").append(`<div><img src='${search}' /></div>`);
          if (bLengthChange[id])
            $("#" + id + "_filter > label > input").attr("placeholder", "Search");
          $("#" + id + "_length > label > select").removeClass();
        }
      })
      setTimeout(function () {
        $('#' + id + '_filter')
      }, 10)

    },
    getProducts() {
      let self = this
      self.loader = true
      self.productOptions = []
      self.selectedProduct = {}
      self.productOptionsFull = []
      const url = "/api/websites/website_products"
      let payload = {}
      payload["website"] = this.selected_website_array
      payload["item_category"] = self.device
      payload['start_date'] = moment(self.reviewStartDate).format('YYYY-MM-DD')
      payload['end_date'] = moment(self.reviewEndDate).format('YYYY-MM-DD')

      self.$http.post(url, payload).then(response => {
        self.loader = false
        self.errorInProduct = false
        if (!response.body.data.length) {
          self.errorInProduct = true
          return
        }
        self.productOptionsFull = response.body.data

        self.filterKeys.brand = response.body.brand_list.sort()
        self.filterKeys.processor_type = response.body.processor_list.sort()

        if ((localStorage.selected_product) && (!self.updateSelectedProduct))
          self.selectedProduct = JSON.parse(localStorage.selected_product)
        else {
          self.selectedProduct = { key: 'all' }
          localStorage.selected_product = JSON.stringify(self.selectedProduct)
        }
        self.filterActions()
        self.updateSelectedProduct = false

      }, err => {
        self.loader = false
        self.errorInProduct = true
      });
    },
    filterActions() {
      this.productOptions = []
      let brandCheck = true
      let cpuCheck = true
      let ratingCheck = true
      let seriesCheck = true

      let ratingExpMapper = {
        'eq': function (a, b) { return a == b },
        'gt': function (a, b) { return b > a },
        'gte': function (a, b) { return b >= a },
        'lt': function (a, b) { return b < a },
        'lte': function (a, b) { return b <= a },
        'between': function (a1, a2, b) { return ((b >= a1) && (b <= a2)) }
      }
      for (let [ii, rr] of this.productOptionsFull.entries()) {
        if (this.brandFilter)
          brandCheck = this.brandFilter == rr.brand_name
        if (this.cpuFilter)
          cpuCheck = this.cpuFilter == rr.processor_type
        if (this.ratingExp != 'between' && this.ratingInput1)
          ratingCheck = ratingExpMapper[this.ratingExp](this.ratingInput1, rr.rating)
        else if (this.ratingExp == 'between' && this.ratingInput1 && this.ratingInput1)
          ratingCheck = ratingExpMapper[this.ratingExp](this.ratingInput1, this.ratingInput2, rr.rating)

        if (this.fourKSeries && this.fiveKSeries)
          seriesCheck = (rr.processor_model[0] == '4') || (rr.processor_model[0] == '5')
        else if (this.fourKSeries && !this.fiveKSeries)
          seriesCheck = (rr.processor_model[0] == '4')
        else if (!this.fourKSeries && this.fiveKSeries)
          seriesCheck = (rr.processor_model[0] == '5')
        if (brandCheck && cpuCheck && ratingCheck && seriesCheck) {
          this.productOptions.push(rr)
        }
      }
      this.refreshReview()
    },

    format(v) {
      return this.$options.filters.format(v)
    },
  }
}

</script>

<style>
#myTable_filter>label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#myTable_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#myTable_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#myTable_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#myTable_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#myTable_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#myTable .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#myTable_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#myTable_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

#myTable_filter div.filter_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}

#myTable_filter div.filter_icon img {
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%) hue-rotate(138deg) brightness(98%) contrast(95%);
}

#myTable_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}

#myTable_info {
  position: relative;
  top: 9px;
  left: 324px;
  z-index: 100;
  float: right;
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#myTable_length {
  /* position: relative;
  top: 90px;
  left: 30px;
  z-index: 100;
  width: 50vw; */
}

#myTable_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#myTable_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#myTable_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#myTable_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#myTable_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#myTable {
  border-radius: 20px 20px 0 0;
}

#myTable .thead-normal,
#myTable .thead-normal tr:first-child,
#myTable .thead-normal>tr:first-child>th:first-child {
  background-color: var(--background) !important;
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}

#myTable .thead-normal>tr:first-child>th:last-child {
  border-radius: 0 21px 0 0;
}

#myTable .thead-normal>tr:first-child>th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 5px 25px;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}

#myTable .thead-normal>tr:last-child>th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 0px 25px 5px 25px !important;
  color: rgb(78 78 78) !important;
}

#myTable th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#myTable tfoot th {
  background-color: var(--background) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#myTable tfoot th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#myTable tbody td {
  /* border-left: 1px solid var(--base_color-20) !important; */
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}

#myTable tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#myTable .even td {
  background: #fff !important;
}

#myTable .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

/* #myTable_wrapper .bottom {
  margin-bottom: -30px;
} */
#myTable_wrapper .row:last-child {
  margin-bottom: 15px;
}

#myTable_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#myTable .thead-normal>tr>th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
}

#myTable .thead-normal>tr>th.sorting:after {
  font-size: 15px;
  color: var(--base_color-80);
}

#myTable_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#myTable_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#myTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--background);
}

#myTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

#myTableModalTable_filter>label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#myTableModalTable_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#myTableModalTable_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#myTableModalTable_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#myTableModalTable_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#myTableModalTable_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#myTableModalTable .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#myTableModalTable_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#myTableModalTable_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

#myTableModalTable_filter div.filter_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}

#myTableModalTable_filter div.filter_icon img {
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%) hue-rotate(138deg) brightness(98%) contrast(95%);
}

/* #myTableModalTable_paginate {
  position: relative;
  top: 70px;
  z-index: 100;
  float: right;
  width: 50vw;
} */
#myTableModalTable_info {
  position: relative;
  /* top: 65px; */
  left: 514px;
  z-index: 100;
  float: right;
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#myTableModalTable_length {
  position: relative;
  top: 30px;
  z-index: 100;
  width: 50vw;
}

#myTableModalTable_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#myTableModalTable_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#myTableModalTable_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#myTableModalTable_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#myTableModalTable_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#myTableModalTable {
  border-radius: 20px 20px 0 0;
}

#myTableModalTable .thead-normal,
#myTableModalTable .thead-normal tr:first-child,
#myTableModalTable .thead-normal>tr:first-child>th:first-child {
  background-color: var(--background) !important;
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}

#myTableModalTable .thead-normal>tr:first-child>th:last-child {
  border-radius: 0 21px 0 0;
}

#myTableModalTable .thead-normal>tr>th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
}

#myTableModalTable .thead-normal>tr>th.sorting:after {
  font-size: 15px;
  color: var(--base_color-80);
}

#myTableModalTable .thead-normal>tr:first-child>th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 5px 25px;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}

#myTableModalTable .thead-normal>tr:last-child>th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 0px 25px 5px 25px !important;
  color: rgb(78 78 78) !important;
}

#myTableModalTable th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#myTableModalTable tfoot th {
  background-color: var(--background) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#myTableModalTable tfoot th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#myTableModalTable tbody td {
  /* border-left: 1px solid var(--base_color-20) !important; */
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}

#myTableModalTable tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#myTableModalTable .even td {
  background: #fff !important;
}

#myTableModalTable .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

#myTableModalTable_wrapper {
  margin-top: -32px;
}

/* #myTableModalTable_wrapper .row:last-child {
  margin-bottom: -30px;
} */
#myTableModalTable_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#myTableModalTable_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#myTableModalTable_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#myTableModalTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--background);
}

#myTableModalTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

/* .modal-title {
  font-weight: 600 !important;
  font-family: "poppins";
}

.modal-header {
  background: var(--primary_brand-20) !important;
  color: var(--base_color);
  border: none;
  display: flex !important;
  justify-content: start !important;
  padding-bottom: 1rem !important;
  font-family: "poppins";
  border-radius: 5px 0px 0px 0px !important;
}

.modal-header .close {
  color: black;
  text-shadow: none;
  position: absolute;
  top: -2px;
  right: -6px;
  font-size: 30px;
  background: var(--primary_brand-10);
  opacity: inherit;
  padding: 5px 10px;
  border-radius: 25px;
} */
</style>

<style scoped>
.inputBoxTitle {
  color: var(--primary_brand);
  font-size: 16px;
  margin-bottom: 5px;
  font-family: "poppins";
}

.productScroll {
  padding-top: 0px;
  cursor: pointer;
  height: 300px;
  overflow-y: scroll;
}

.selectedProduct {
  background: #8e8d8d !important;
  color: White !important;
}

.lastUpdated {
  margin-right: 58px;
  background: grey;
  color: white;
  font-size: 15px;
  line-height: 28px;
  padding: 5px 9px 8px 8px;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem !important;
}

.lastUpdated {
  background: var(--base_color-60);
  color: white;
  font-size: 15px;
  line-height: 32px;
  padding: 6px 12px;
  border-radius: 4px;
}

.cardper {
  float: right;
  position: absolute;
  right: 11px;
  bottom: 0;
  font-size: 29px;
  color: white;
}

.space-between-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;

  padding-bottom: 5px;
}

.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}

.space-between-header h3 {
  color: #4e4e4e;
  margin-bottom: 0;
  line-height: 31px;
}

.mycols:first-child {
  padding-right: 2px !important
}

.mycols:last-child {
  padding-left: 2px
}

.mycols:not(:first-child):not(:last-child) {
  padding-left: 2px;
  padding-right: 2px
}

.customselect {
  height: 34px;
  border-radius: 0;
  background: white;
  border: 1px solid silver;
  padding-left: 11px;
  padding-right: 11px;
  margin-right: 5px;
}

.eachProduct:hover {
  background: #d4d4d4;
}

#myTable th,
#keywordTableModal th {
  text-align: center
}

#myTable th,
#myTable td,
#keywordTableModal th,
#keywordTableModal td {
  border-right: 1px solid silver !important;
  border-bottom: 1px solid silver !important;
  padding-left: 2px;
  padding-right: 2px;
}

#myTable,
#keywordTableModal {
  margin-top: 12px
}

.custom_websiteMenu {
  border: 1px solid silver;
  background: white;
  width: max-content;
  position: absolute;
  z-index: 1;
  height: 300px;
  overflow-y: scroll;
  min-width: 200px
}

.custom_websiteMenuItems {
  font-size: 11px;
  color: #5c6873;
}

.custom_optgroup {
  font-weight: bolder;
  padding-left: 9px;
}

.custom_option {
  padding-left: 18px;
}


.custom_dropdown {
  text-transform: uppercase;
  -youbkit-touch-callout: none;
  /* iOS Safari */
  -youbkit-user-select: none;
  /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE 10+ and Edge */
  user-select: none;
}

.custom_dropdown_wrap {
  cursor: pointer;
  display: flex;
  border: 1px solid silver;
  background: white;
  justify-content: space-between;
  padding: 7px;
  height: 30px;
}

.custom_dropdown_title {
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.datebox {
  width: 14% !important;
}


#keyword_newtable {
  --border: 1px solid var(--base_color-20);
  border-radius: 10px;
  border-spacing: 0;
  border-collapse: separate;
  border: var(--border);
  overflow: hidden;
}

#keyword_newtable th:not(:last-child),
#keyword_newtable td:not(:last-child) {
  border-right: var(--border) !important;
}

#keyword_newtable>thead>tr:not(:last-child)>th,
#keyword_newtable>thead>tr:not(:last-child)>td,
#keyword_newtable>tbody>tr:not(:last-child)>th,
#keyword_newtable>tbody>tr:not(:last-child)>td,
#keyword_newtable>tfoot>tr:not(:last-child)>th,
#keyword_newtable>tfoot>tr:not(:last-child)>td,
#keyword_newtable>tr:not(:last-child)>td,
#keyword_newtable>tr:not(:last-child)>th,
#keyword_newtable>thead:not(:last-child),
#keyword_newtable>tbody:not(:last-child),
#keyword_newtable>tfoot:not(:last-child) {
  border-bottom: var(--border) !important;
}

#keyword_newtable th {
  background: var(--background);
  padding: 0.6rem !important;
  font-size: 14px !important;
  font-family: "Poppins", sans-serif !important;
}

#keyword_newtable td {
  padding: 4px !important;
  font-size: 14px !important;
  font-family: "Heebo", sans-serif !important;
}


.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.exportButton {
  margin-left: 6px;
  height: 35px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 25px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.exportButton:hover {
  color: white !important;
  background: var(--primary_brand-80) !important;
  font-family: "poppins";
}

@media only screen and (max-width: 1700px) {
  .primarycolor {
    padding: 5px 10px !important;
  }

  .custom_dropdown {}
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.backIcon {
  filter: brightness(0) saturate(100%) invert(98%) sepia(0%) saturate(206%) hue-rotate(268deg) brightness(116%) contrast(100%);
}

.searchInput input {
  height: 35px !important;
  margin-right: -5px !important;
  font-size: 14px !important;
  border-color: var(--primary_brand-60) !important;
  font-family: "poppins";
}

.searchInput input::placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input:focus {
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
  font-family: "poppins";
}

.searchIcon {
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-family: "poppins";
  background-color: var(--primary_brand);
}

.searchIcon img {
  width: 25px;
  margin: 10px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

.ratingSection {
  display: flex;
  justify-content: start;
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;
}

.ratingSectionItem {
  width: 25%;
}

.checkbox-btn {
  margin-right: 6px;
  height: 35px !important;
  display: flex;
  align-items: center;
  border: none;
  background-color: var(--base_color-10);
  border-radius: 5px;
  color: #000;
  padding: 0px 10px;
  font-family: "poppins";
}

.checkbox-btn span {
  padding: 0 5px;
  margin-left: 10px;
  font-family: "poppins";
}

.checkbox-btn input {
  margin: 4px;
  font-size: 11px;
  accent-color: #fff;
  width: 15px;
  height: 15px;
  font-family: "poppins";
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  margin-bottom: -20px !important;
}
</style>



<style>
/* .modal-header {
  background: var(--primary_brand-20) !important;
  color: var(--base_color);
  border: none;
  display: flex !important;
  justify-content: start !important;
  padding-bottom: 1rem !important;
  font-family: "poppins";
  border-radius: 5px 0px 0px 0px !important;
}

.modal-header .close {
  color: black;
  text-shadow: none;
  position: absolute;
  top: -2px;
  right: -6px;
  font-size: 30px;
  background: var(--primary_brand-10);
  opacity: inherit;
  padding: 5px 10px;
  border-radius: 25px;
} */

.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  overflow-y: auto;
  font-family: "poppins";
}

.customMultiselect .multiselect__input {
  border: var(--base_color-20) !important;
  height: 30px !important;
}

.customMultiselect .multiselect__input:focus {
  outline: none !important;
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

.customMultiselect .multiselect__option--group {
  background-color: #44777A !important;
  color: white !important;
  font-size: 16px;
}

.customMultiselect .multiselect__option--highlight::after {
  font-size: 10px !important;
  padding-inline: 6px !important;
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}
</style>